// get the audio and video feeds
let rssFeed = null;
let ytFeed = [];

function generateEpisodeBox(
mainContainerQuery,
 boxContainerQuery,
 playlistId,
 getAll
) {
  // grab the containers
  const mainContainer = document.querySelector(mainContainerQuery);
  const boxContainer = document.querySelector(boxContainerQuery);

  let rssApi =
      "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Ffeed.podbean.com%2Fjustrollwithit%2Ffeed.xml&api_key=8q3g7czgxkkdgvfl5s5g0gxbyyuhgqipr1c0tgmm&count=1000";

  const getRssFeed = function(api) {
    fetch(api)
    .then((response) => response.json())
    .then((data) => {
      rssFeed = data.items;

      runLoop();
    });
  }

  let ytApi =
      "https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=200&playlistId=" +
      playlistId +
      "&maxResults=50&key=AIzaSyA-yIaat4lxTLfAqBouKz6NPqAfpDuTk_g"; 

  const getYtVideos = function(api) {
    fetch(api)
    .then((response) => response.json())
    .then((data) => {
      ytFeed = ytFeed.concat(data.items);

      if(data.nextPageToken !== undefined) {
        // then we need to get more
        getYtVideos(ytApi + "&pageToken=" + data.nextPageToken);
      } else {
        getRssFeed(rssApi);
      }
    });
  }

  getYtVideos(ytApi);

  const findObjectByKey = function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (
        array[i][key] === value ||
        array[i][key].includes(value) ||
        value.includes(array[i][key])
      ) {
        return array[i];
      }
    }
    return null;
  };

  const runLoop = function () {
    for (var i = 0; i < ytFeed.length; i++) {
      // get the youtube episode
      let videoEp = ytFeed[ytFeed.length - 1 - i].snippet;
      console.log(videoEp);

      // find the first episode that has a match for the video title
      let title = videoEp.title;
      let audioEp = findObjectByKey(rssFeed, "title", title);
      console.log(title, audioEp);

      if (audioEp !== null) {
        // then we have a match and we can render
        const episodeBox = document.createElement("div");
        episodeBox.className = "episodeBox";

        const episodeTitle = document.createElement("div");
        episodeTitle.className = "episode-title";
        episodeBox.appendChild(episodeTitle);

        const audioVideo = document.createElement("div");
        audioVideo.className = "audio-video";
        episodeBox.appendChild(audioVideo);

        const audioBox = document.createElement("div");
        audioBox.className = "audio";
        audioVideo.appendChild(audioBox);

        const videoBox = document.createElement("div");
        videoBox.className = "video";
        audioVideo.appendChild(videoBox);

        let titleHeading = document.createElement("h3");
        titleHeading.innerText = title.split(" | ")[0];
        episodeTitle.appendChild(titleHeading);

        let description = audioEp.description;
        let descriptionBox = document.createElement("div");
        descriptionBox.className = "description-box";
        descriptionBox.innerHTML = description;
        episodeTitle.appendChild(descriptionBox);

        // AUDIO
        let audio = document.createElement("audio");
        audio.src = audioEp.enclosure.link;
        audio.controls = true;
        audioBox.appendChild(audio);

        // VIDEO
        let iframe = document.createElement("iframe");
        iframe.className = "episodeVideo";
        iframe.title = videoEp.title;
        iframe.src =
          "https://www.youtube.com/embed/" + videoEp.resourceId.videoId;
        videoBox.appendChild(iframe);

        // get the maxres thumbnail
        let thumbnailElem = getAll ? episodeBox : mainContainer;
        let thumbnail = videoEp.thumbnails.maxres || videoEp.thumbnails.high;
        thumbnailElem.style.background = "url(" + thumbnail.url + ")";
        thumbnailElem.style.backgroundSize = "cover";

        // and then put the episodeBox in the boxContainer
        boxContainer.appendChild(episodeBox);

        // also, if we are only rendering one, then break the loop here
        if (!getAll) {
          break;
        }
      } else {
        // then we don't have a match, so move on
        console.log("Couldn't find a match, so moving on");
      }
    }
  };
}

const scrollElements = document.querySelectorAll(".imgs .camp1, .imgs .camp2");

const elementInView = (el, dividend = 1) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop <=
    (window.innerHeight || document.documentElement.clientHeight) / dividend
  );
};

const elementOutofView = (el) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

const displayScrollElement = (element) => {
  element.classList.add("animated");
};

const hideScrollElement = (element) => {
  element.classList.remove("animated");
};

const handleScrollAnimation = () => {
  scrollElements.forEach((el) => {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el);
    }
  });
};

window.addEventListener("scroll", () => {
                        handleScrollAnimation();
});
